import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AgentBranchAccessIndex from './Index.vue';

// V1 · Permisos de Sucursal por Agente · 2026-05-14 (Victor)
// Solo super_admin · gate adicional dentro del componente (onMounted redirect).
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-branch-access'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_agent_branch_access',
          component: AgentBranchAccessIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
